/**
 * Method to obtain claims dictionary from jwt
 * @param {jwt} token 
 * @returns dictionary of claims keys and values [ { key: 'key', value: 'value' } ]
 */
export function parseClaims(token) {
    var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
    return Object.entries(JSON.parse(jsonPayload)).map((x) => ({key: x[0], value: x[1]})) ?? [];
}